module.exports = {
  primaryColor: "#22b3be",
  secondaryColor: "#ed475f",
  companyName: "Focus Motors",
  shortName: "Focus",
  siteMetadata: {
    websiteTitle: "Focus",
    description: "Focus motors",
    keywords: "",
    faviconUrl: "",
    logoUrl: "",
    secondaryLogo: "",
  },
  apiEndpointDev: "https://test-api.focusmotors.in/",
  apiEndpointProd: "https://api.focusmotors.in/",
  apiEndpointLocal: "http://192.168.1.5:4000/",
  // apiEndpointLocal: "https://db0c6a422c64.ngrok-free.app",

  frontEndUrl: "",
  tokenPrefix: "focus_token",
}
